import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';

import * as $ from 'jquery';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  selectedProject: any = undefined;
  buttonActive: boolean = false;

  projects: any[] =
  [
    {id: 1, title: 'Open Source ICT-Platform', indiener: `Vereniging Noorden Duurzaam. (2) <br/> Peter Bootsma: E: <a href="mailto:peter.bootsma@noordenduurzaam.nl">peter.bootsma@noordenduurzaam.nl</a>
      `, Consortium: `VND/RUG/RadboudU/Lijnspel/Netwerk&co/
      Coöperatieve samenleving/MRA-Voedselraad`, 
      DilemmaSlashVraagstukSlashVraagstuk: `Regionale ondersteuning van duurzaamheidsnet-
      werken dragen bij aan nieuwe democratie, maar vergen wel stabiele infrastructuur. Prototype is aanwezig. Doorontwikkeling noodzakelijk.`, 
      ContextEnDoorloop: `Het systeem moet meervoudig getoetst worden
      (verschillende domeinen): bouw/ontwikkeling 2018/19
      `, DeliverableNu: `Beslisdocument strategisch, tactisch, operationeel voor te bouwen ICT systeem`},
          
          
    {id: 4, title: 'Rijnlands gebiedsarrangement', indiener: `Coöperatieve samenleving. (2) <br/>Eduard van Ravenhorst <br>E: <a href="mailto:eduard.ravenhorst@tsgnetwerk.nl">eduard.ravenhorst@tsgnetwerk.nl</a>
      `, Consortium: `Coöperatieve samenleving/Waterpoort/de
      Wierden/Beuningen(?)`, 
      DilemmaSlashVraagstuk: `Grote opgaven van deze tijd moeten vanuit mentaal 
      eigenaarschap in het gebied en met nieuwe (Treuhand?) systemen verrekend worden. Concepten en juridische ruimte (EU) zijn beschikbaar, maar nu testen en toepassen.`,
      ContextEnDoorloop: `Langjarige ontwikkeling nu ordenen en testen en
      daarna door ontwikkelen.`, 
      DeliverableNu: `Gebiedsarrangement concept en operationeel
      getoetst in Waterpoort en evt andere regio’s, overdraagbaar in stappenplan.`},
          
    
    {id: 5, title: 'De Regionale Transitieacademie', indiener: `Prov. Limburg/COS Limburg (1):<br/> Ronald Cohnen E: <a href="mailto:R.Kohnen@coslimburg.nl">R.Kohnen@coslimburg.nl</a><br/> Jifke Sol: <a href="mailto:jife.sol@wur.nl">jifke.sol@wur.nl</a>`, 
      Consortium: `Lijnspel/Jifke Sol-Cocreatie-WUR/Jules Hinssen-Fontys/prov. Limburg/samenwerking prov. ZH-regionale initiatieven en netwerken Limburg.`, 
      DilemmaSlashVraagstuk: `<p>In het huidige tussenveld vragen het oude systeem en nieuwe emergente netwerken om aandacht. Dat heeft ondersteuning nodig, om te voorkomen dat belangrijke personen uitstappen, initiatieven stranden en bronnen opdrogen. Een RTA biedt steun in de vorm van een infrastructuur voor maatschappelijk leren.</p>`,
      ContextEnDoorloop: `uitvoering RTA als pilot en daarna als infrastructuur
      2018-2019 in Limburg en elders.`, DeliverableNu: `Inzicht in de behoefte en een voorstel voor het
      concrete RTA werkaanbod waarmee een levende infrastructuur voor maatschappelijk leren in regionale netwerken tot stand komt (fase 1 van een RTA). Het inzicht is overdraagbaar naar andere regio’s in Nederland.`
    },
    
    
    {id: 6, title: 'Succesfactoren maatschappelijk leren', indiener: `Jules Hinssen Jifke Sol (4)<br> E: <a href="mailto:jpphinssen@ziggo.nl">jpphinssen@ziggo.nl</a>`,
     Consortium: 'PZH/Netwerk&Co/ProvL/Groen Verbindt', 
     DilemmaSlashVraagstuk: `Maatschappelijk leren is belangrijk in regionale  
      netwerken, maar kost tijd en wordt binnen bestaande 
      kaders niet of nauwelijks gewaardeerd. Risico is dat partijen afhaken. Hoe organiseer je continuïteit?`, 
      ContextEnDoorloop: `Ontwikkeling RTA-Limburg en gebiedsateliers PZH –
      operationele leerinfrastructuur 2018-2019`, 
      DeliverableNu: `Diagnose en bouwstenen voor design (april 2018) voor
      RTA, Gebiedsateliers en PTRN`
    },
    
    
    {id: 7, title: 'Moderne herverdeling', indiener: `Jurgen vd Heijden (4) <br> E: <a href="mailto:jurgen.vanderheijden@atosborne.nl">jurgen.vanderheijden@atosborne.nl</a>`, 
      Consortium: 'AT Osborne/div partijen binnen en buiten PTRN', 
      DilemmaSlashVraagstuk: `Het herverdelen van welvaart behoeft niet alleen via
      centrale systemen (zoals belasting) te lopen. Regionale netwerken lenen zich ervoor dat soepel en effectief te doen (hypothese)`, 
      ContextEnDoorloop: `Doorgaand onderzoek naar diepe maatschappelijke 
      veranderingen (systeemniveau)`, DeliverableNu: `
        <ul>
          <li>We laten de systeemwereld beter dan voorheen de
      economische en maatschappelijke waarde zien van bottom up projecten, omdat we dit met behulp van het begrip (her)verdeling harder dan ooit kunnen maken. Wij brengen voor hen het directe nut van regionale netwerken in beeld.</li>
          <li>We laten de leefwereld zien hoe zij hun economische en maatschappelijke waarde kunnen aantonen aan systeempartijen, zoals overheden en financiers. Ook voor hen brengen wij het directe nut van regionale netwerken in beeld, maar dan wat zij als onderdeel van die netwerken kunnen betekenen voor elkaar en voor het beter laten functioneren van de systeemwereld.</li>
        </ul>`
    },
    
    
    {id: 8, title: 'Voedsel verbindt', indiener: `Food Councul-Jeffrey Spangenberg:<br> E: <a href="mailto:spang31@gmail.com">spang31@gmail.com</a>`, 
      Consortium: `MRA/Jifke Sol/prov. Noord
      Holland /Hivos/Common Land`, 
      DilemmaSlashVraagstuk: `Hoe bouw je een levensvatbaar netwerk met een
      houdbare bedrijfsvoering, waarin je passie, ontwikkeling en verantwoording evenwichtig combineert? Nodig: infrastructuur, werving grote spelers en verdienmodel.`,
      ContextEnDoorloop: `Flow of foods heft grote ambitie om Foodcouncil in
      MRA op te richten. Daarachter een maatschappelijk regionaal netwerk. `, 
      DeliverableNu: `Governance, organisatie- en gidsplan, verdienmodel,
      Communicatieplan, businessplan, netwerkopbouw.`
    },
          
    
    {id: 9, title: 'Coöperatief Energieconcept', indiener: 'Coöperatie Bommelerwaar', Consortium: `Gemeente Bronckhorst, gemeente wierden, CO-OP
      Champions`, DilemmaSlashVraagstuk: `de energietransitie leidt tot onvoldoende democratisering.
      Voor zowel de grote partijen als  de meeste burgerinitiatieven  blijft het doel om rendement op investering te halen, waardoor opwekken en doorverkoop van energie exclusief blijft. Bommelerwaar-Stroom is het coöperatieve antwoord en dat ligt voor 80% klaar.`,
      ContextEnDoorloop: `december 2017 – 1 april 2018: binnen 3 maanden is
      Bomelerwaar-Stroom operationeel met als doel om 2018 ten minste 1000 deelnemers te verbinden aan lokale energie-opwek in de Bommelerwaard.`, 
      DeliverableNu: `een kopieerbaar prototype van een echt coöperatief local-
      for-local energieconcept: vanuit de energie rekening investeren deelnemers in collectieve, lokale energie-opwek. Concreet leveren we op: propositie consumenten, propositie dakeigenaren, Bommelerwaar-Stroom stroom overeenkomst, dakhuur- en opstalovereenkomst, zonnedak offerteuitvraag, overeenkomst energiebedrijf, klanten-contract energiebedrijf.ect`
   },
    
    
    {id: 10,  title: 'Vreedzaam leren en doen', indiener: `Gebied coöperatie rivierenland (2) <br/> Andrea Zierleyn: E: <a href="mailto:a.zierleyn@GCRievierenland.nl">a.zierleyn@GCRivierenland.nl</a> `,
     Consortium: `GCR/Regio Rivierenland/AT Osborne/gebiedspartijen
      Rabo/Fruitmotor/TNO`,
      DilemmaSlashVraagstuk: `Waarde en kwetsbaarheid van een gebied zijn 
      onvoldoende bekend en hanteerbaar voor duurzame gebiedsontwikkeling.`, 
      ContextEnDoorloop: `Ontwikkeling masterclasses en toolkit; samen 
      elementen ontwerpen van gebiedsboekhouding.`, 
      DeliverableNu: `Overdraagbaar curriculum masterclass; eerste 
      instrument toolkit/gebieds (maart 2018)`},
  ];

  show: boolean = false;

  constructor(public navCtrl: NavController) {
  }

  hide() {
    if(!this.buttonActive) {
      this.selectedProject = undefined;
    }
  }

  showProject(project: any) {
      this.buttonActive = true;
      this.selectedProject = project;
      setTimeout(() => {
        this.buttonActive = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts